import {forward} from 'effector';

import {setIsNG, setProfile} from './models/utils';

import './models/common/init';
import './models/create/init';
import './models/details/init';
import './models/utils/init';
import './core/localization/init';
import {CreateInvoiceAdapter} from './ports';

let adapter: CreateInvoiceAdapter | null = null;

export function setAdapter(a: CreateInvoiceAdapter): void {
    adapter = a;
}

export function getAdapter(): CreateInvoiceAdapter {
    if (adapter == null) {
        throw new Error(
            '[create-invoice-new] Module not initialized. Call initCreateInvoiceModule(adapter) before using CreateInvoiceNew.',
        );
    }
    return adapter;
}

export function initCreateInvoiceModule(config: CreateInvoiceAdapter): void {
    // config.profile.watch((profile) => {
    //     setProfile(profile);
    // });
    setProfile(config.profile.getState());
    forward({from: config.profile, to: setProfile});
    setIsNG(config.isNG);
    setAdapter(config);
}
